import React from 'react'
import "../styles/singleproject.css";
import { Link } from 'react-router-dom';
const SingleProject =({items}) => {
    return (
        <div className='card-center'>
    {items.map((cardItem) => {
    const{id,title,description,website,img,github,techstack} = cardItem
    return (
<article key={id} className="single-project-card">
    <div className='img-container'>
    <img src={img} alt={title}/>
    </div>
    <div className='card-footer'>
        <h3> {title}</h3>
       <p  className='techstack'>{techstack}</p>
      
        <p>{description}</p>
        <a href={website} className="btn">website</a>
       <a href={github} className='btn'>github</a>
    </div>
    
</article>
    )
})}
</div>

    )
}
 export default SingleProject